import React, { useEffect, useState } from "react";
import Chart from "react-google-charts";
import { useDispatch, useSelector } from "react-redux";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { ApplicationState } from "../../store";
import * as TransactionActions from "../../store/transaction/actions";

const TransactionGraph = () => {
    // variable - chart
    let dataForChart: any = null;
    let dataForAlertChart: any = null;
    dataForChart = [];
    dataForAlertChart = [];
    let chartOptions: any = {};
    let alertChartOptions: any = {};
    dataForChart.push(["Month", "Transactions"]);
    dataForAlertChart.push(["Month", "Alerts"]);
    let minValue: number = 10000000;
    let maxValue: number = 0;
    let minAlertValue: number = 10000000;
    let maxAlertValue: number = 0;
    const [showTransactionsGraph, setShowTransactionsGraph] = useState(true);

    // useState
    const [transactionCount, setTransactionCount] = useState(0);

    // action dispatch
    const dispatch = useDispatch();
    const requestChartData = () => dispatch(TransactionActions.actionCreators.requestChartData());
    const [tooltipTrigger, setTooltiptrigger] = useState(false);
    const [tooltipAlertTrigger, setTooltipAlerttrigger] = useState(false);
    const summaryData = useSelector((state: ApplicationState) => state.accountSummaryData == null || state.accountSummaryData.accountSummaryData == null ? [] : state.accountSummaryData.accountSummaryData["data"]);
    // useSelector
    const chartDataFromAPI = useSelector((state: ApplicationState) => {
        if (state.recentTransactionData.recentTransactionData != null && state.recentTransactionData.recentTransactionData.data != null) {
            if (transactionCount === 0 && state.recentTransactionData.recentTransactionData.data.length !== 0) {
                setTransactionCount(state.recentTransactionData.recentTransactionData.data.length);
            }
        }
        return state.transactionChartData.transactionChartData == null ? null : state.transactionChartData.transactionChartData.data;
    });

    const setChartOptions = () => {
        chartOptions = {
            title: "",
            hAxis: {
                title: "",
                titleTextStyle: {
                    color: "#333",
                },
                gridlineColor: "#FFFFFF",
            },
            vAxis: {
                title: "",
                viewWindow: {
                    max: maxValue,
                    min: 0,
                },
                baselineColor: "#e3e3e3",
                gridlineColor: "#FFFFFF",
            },
            focusTarget: "category",
            colors: ["#0A7087", "#FFA126", "#DE2E21"],
            legend: {
                position: "none",
            },
            tooltip: {
                isHtml: true,
                trigger: tooltipAlertTrigger == false ? 'selection' : 'none',
            },
            bar: { groupWidth: "50%" },
            chartArea: {
                left: 32,
                top: 32,
                bottom: 60,
                right: 0,
                width: "100%",
                height: "100%",
            },
            animation: {
                startup: true,
                easing: "linear",
                duration: 1000,
            },
        };
    };
    const setAlertChartOptions = () => {
        alertChartOptions = {
            title: "",
            hAxis: {
                title: "",
                titleTextStyle: {
                    color: "#333",
                },
                gridlineColor: "#FFFFFF",
            },
            vAxis: {
                title: "",
                viewWindow: {
                    max: maxAlertValue,
                    min: 0,
                },
                viewWindowMode: "explicit",
                baselineColor: "#e3e3e3",
                gridlineColor: "#FFFFFF",
                format: ""
            },
            focusTarget: "category",
            colors: ["#FFA126"],
            legend: {
                position: "none",
            },
            tooltip: {
                isHtml: true,
                trigger: tooltipTrigger == false ? 'selection' : 'none',
            },
            bar: { groupWidth: "50%" },
            chartArea: {
                left: 32,
                top: 32,
                bottom: 60,
                right: 0,
                width: "100%",
                height: "100%",
            },
            animation: {
                startup: true,
                easing: "linear",
                duration: 1000,
            },
        };
    };
    // useEffect
    const renderChartData = () => {
        if (chartDataFromAPI != null && chartDataFromAPI.length > 0) {
            let intTransaction, intAlert;
            chartDataFromAPI.forEach((data) => {
                intTransaction = parseInt(data["regular-transactions"], 10);
                intAlert = parseInt(data["alerted-transactions"], 10);
                if (intTransaction >= maxValue) {
                    maxValue = intTransaction;
                }
                if (intAlert >= maxAlertValue) {
                    maxAlertValue = intAlert;
                }

                if(maxAlertValue === 0){
                    maxAlertValue = 1;
                }
                if (intTransaction <= minValue) {
                    minValue = intTransaction;
                }
                if (intAlert <= minAlertValue) {
                    minAlertValue = intAlert;
                }
                dataForChart.push([data["month"].substring(0,3) + " "  + "'"+ data["year"].slice(-2), intTransaction]);
                dataForAlertChart.push([data["month"].substring(0,3)+ " " + "'"  + data["year"].slice(-2), intAlert]);
            });
        } else if (chartDataFromAPI != null && chartDataFromAPI.length === 0) {
            minValue = 0;
            maxValue = 1;
            minAlertValue = 0;
            maxAlertValue = 1;
        }
        setChartOptions();
        setAlertChartOptions();
    };

    const ensureDataFetched = () => {
        requestChartData();
    };

    useEffect(ensureDataFetched, []);

    if (chartDataFromAPI != null && chartDataFromAPI.length > 0) {
        renderChartData();
    }

    return (
        <React.Fragment>
            <div className="row" id="content">
                <div className="col-xs">
                    {transactionCount != null && transactionCount !== 0 && !!summaryData && chartDataFromAPI != null && chartDataFromAPI.length > 0 ? (
                        <div className="box">
                            <div className="box-content">
                                <div className="row between-xs between-sm">
                                    <div className="col-xs flex-grow-null col-sm col-no-gutter graph-box-title">
                                        <h3 className="content-sub-title">
                                            Activity
                                        </h3>
                                        <div style={{display:"flex"}}>
                                        <h3 className={`btn-default txn-btn-tab ${showTransactionsGraph && 'txn-tab-active'}`} onClick={()=>setShowTransactionsGraph(true)}>Transactions</h3>
                                        <h3 className={`btn-default txn-btn-tab ${!showTransactionsGraph && 'txn-tab-active'}`} onClick={()=>setShowTransactionsGraph(false)}>Alerts</h3>
                                        </div>
                                    </div>
                                    {showTransactionsGraph && <div id="chart-transactions" className="m-chart-container chart-transactions">
                                        {chartDataFromAPI != null && chartDataFromAPI.length > 0 && (
                                            <Chart
                                                chartType="ColumnChart"
                                                loader={<div>Loading Chart</div>}
                                                data={dataForChart}
                                                options={chartOptions}
                                                rootProps={{ "data-testid": "3" }}
                                                chartEvents={[
                                                    {
                                                        eventName: "ready",
                                                        callback: ({ chartWrapper, google }) => {
                                                            var chart = new google.visualization.ColumnChart(document.getElementById('chart-transactions'));
                                                            document.addEventListener('keydown', (event) => {
                                                                if (event.key === 'Escape') {
                                                                    setTooltiptrigger(true);
                                                                    event.stopImmediatePropagation();
                                                                    setTooltiptrigger(false);
                                                                }
                                                            });
                                                            const datachart = document.getElementsByClassName('google-visualization-tooltip');
                                                            document.addEventListener('mousedown', (event) => {
                                                                if (datachart.length != 0) {
                                                                    if (event instanceof MouseEvent) {
                                                                        setTooltiptrigger(true);
                                                                        setTooltiptrigger(false);
                                                                    }
                                                                }
                                                            });
                                                            setTimeout(() => {
                                                                var svg = chart.getContainer().getElementsByTagName('svg');
                                                                if (svg.length > 0) {
                                                                    svg[0].setAttribute('aria-label', 'Transaction Activity Bar Graph');
                                                                    svg[0].setAttribute('role', 'img');
                                                                }
                                                                if (chart) {
                                                                    if (chart.getContainer()) {
                                                                        var divWithAriaLabel = chart.getContainer().querySelectorAll("div[aria-label]");
                                                                        if (divWithAriaLabel.length > 0) {
                                                                            divWithAriaLabel.forEach(function (div: HTMLDivElement) {
                                                                                div.setAttribute('role', 'region');
                                                                            });
                                                                        }
                                                                    }
                                                                }
                                                            }, 500);
                                                        }
                                                    }
                                                ]}
                                            />
                                        )}
                                    </div>}
                                    {!showTransactionsGraph && <div id="alert-chart-transactions" className="m-chart-container chart-transactions">
                                    {chartDataFromAPI != null && chartDataFromAPI.length > 0 && !showTransactionsGraph && (
                                            <Chart
                                                chartType="ColumnChart"
                                                loader={<div>Loading Chart</div>}
                                                data={dataForAlertChart}
                                                options={alertChartOptions}
                                                rootProps={{ "data-testid": "3" }}
                                                chartEvents={[
                                                    {
                                                        eventName: "ready",
                                                        callback: ({ chartWrapper, google }) => {
                                                            var chart = new google.visualization.ColumnChart(document.getElementById('alert-chart-transactions'));
                                                            document.addEventListener('keydown', (event) => {
                                                                if (event.key === 'Escape') {
                                                                    setTooltipAlerttrigger(true);
                                                                    event.stopImmediatePropagation();
                                                                    setTooltipAlerttrigger(false);
                                                                }
                                                            });
                                                            const datachart = document.getElementsByClassName('google-visualization-tooltip');
                                                            document.addEventListener('mousedown', (event) => {
                                                                if (datachart.length != 0) {
                                                                    if (event instanceof MouseEvent) {
                                                                        setTooltipAlerttrigger(true);
                                                                        setTooltipAlerttrigger(false);
                                                                    }
                                                                }
                                                            });
                                                            setTimeout(() => {
                                                                var svg = chart.getContainer().getElementsByTagName('svg');
                                                                if (svg.length > 0) {
                                                                    svg[0].setAttribute('aria-label', 'Transaction Activity Bar Graph');
                                                                    svg[0].setAttribute('role', 'img');
                                                                }
                                                                if (chart) {
                                                                    if (chart.getContainer()) {
                                                                        var divWithAriaLabel = chart.getContainer().querySelectorAll("div[aria-label]");
                                                                        if (divWithAriaLabel.length > 0) {
                                                                            divWithAriaLabel.forEach(function (div: HTMLDivElement) {
                                                                                div.setAttribute('role', 'region');
                                                                            });
                                                                        }
                                                                    }
                                                                }
                                                            }, 500);
                                                        }
                                                    }
                                                ]}
                                            />
                                        )}
                                        </div>}
                                </div>
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
        </React.Fragment>
    );
};

export default TransactionGraph;
